import {
  getBlogPath,
  getNewNotifications,
  getNotifications,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { blogActions } from "../reducers/blog";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchBlogList = (id = 0) => {
  return (dispatch) => {
    return apiService
      .get(getBlogPath(id))
      .then((response) => {
        if (id === 0) {
          dispatch(blogActions.fetchBlogList(response.data));
        } else {
          dispatch(blogActions.fetchBlogDetail(response.data));
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchNewNotificationList = () => {
  return (dispatch) => {
    return apiService
      .get(getNewNotifications())
      .then((response) => {
        dispatch(blogActions.fetchNotificationList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchPageNotificationList = (page = 10) => {
  return (dispatch) => {
    return apiService
      .get(getNotifications(page))
      .then((response) => {
        dispatch(blogActions.fetchNotificationList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("security.error.refresh"), { theme: "colored" });
  }
  toast.error(errorMessage, { theme: "colored" });
};
